// hooks/useImageViewer.js
import { useState, useCallback } from "react"

export const useImageViewer = () => {
  const [viewerOpen, setViewerOpen] = useState(false)
  const [selectedImageUrl, setSelectedImageUrl] = useState("")
  const [imageTitle, setImageTitle] = useState("")

  const openImageViewer = useCallback((url, title = "Document") => {
    setSelectedImageUrl(url || "")
    setImageTitle(title)
    setViewerOpen(true)
  }, [])

  const closeImageViewer = useCallback(() => {
    setViewerOpen(false)
  }, [])

  return {
    viewerOpen,
    selectedImageUrl,
    imageTitle,
    openImageViewer,
    closeImageViewer,
  }
}